import * as Sentry from "@sentry/react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { ScrollToTop } from "@/components/scroll-to-top";
import { About } from "@/pages/about";
import { AdminCalendarPage } from "@/pages/admin-calendar";
import { AdminReservationsPage } from "@/pages/admin-reservations";
import { AdminSettingsPage } from "@/pages/admin-settings";
import { BookPage } from "@/pages/book";
import { BookGuestDetailsPage } from "@/pages/book-guest-details";
import { BookSelectVillaPage } from "@/pages/book-select-villa";
import { Contact } from "@/pages/contact";
import { Dining } from "@/pages/dining";
import { Gallery } from "@/pages/gallery";
import { Home } from "@/pages/home";
import { LoginPage } from "@/pages/login";
import { NotFound } from "@/pages/not-found";
import { Rooms } from "@/pages/rooms";
import { Spa } from "@/pages/spa";
import { Unauthorized } from "@/pages/unauthorized";
import { Providers } from "@/providers";

function AppRoutes() {
  return (
    <Router>
      <ScrollToTop />
      <Providers>
        <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/rooms" element={<Rooms />} />
            <Route path="/dining" element={<Dining />} />
            <Route path="/spa" element={<Spa />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/book" element={<BookPage />} />
            <Route path="/book/select-villa" element={<BookSelectVillaPage />} />
            <Route path="/book/guest-details" element={<BookGuestDetailsPage />} />
            <Route path="/admin/reservations" element={<AdminReservationsPage />} />
            <Route path="/admin/calendar" element={<AdminCalendarPage />} />
            <Route path="/admin/settings" element={<AdminSettingsPage />} />
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Sentry.ErrorBoundary>
      </Providers>
    </Router>
  );
}

export default AppRoutes;
